import BonanzaListingTable from './bonanzaListingTable.container'

export default BonanzaListingTable